import { DealScreenState } from './reducer'

export const getDealScreenRows = (state: { dealScreen: DealScreenState }) =>
  state.dealScreen.rows

export const getDealScreenLoader = (state: { dealScreen: DealScreenState }) =>
  state.dealScreen.isLoading

export const isDealScreenStale = (state: { dealScreen: DealScreenState }) =>
  state.dealScreen.stale
